/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { IntegrationSection } from './IntegrationSection/IntegrationSection'
import useUser from '../Shared/UserProvider/useUser'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import { BusinessPerformanceSection } from './BusinessPerformanceSection/BusinessPerformanceSection'
import { OperationalPerformanceSection } from './OperationalPerformanceSection/OperationalPerformanceSection'
import { OfferPerformanceSection } from './OfferPerformanceSection/OfferPerformanceSection'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../NavBar/useBreadcrumb'
import { FeatureInfo } from '../Shared/FeatureInfo/FeatureInfo'


const Dashboard = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()
    const { user } = useUser()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: false,
            path: '/',
        }])
    }, [setPaths, t])

    return (
      <>
          <FeatureInfo featureName="dashboard"
                       css={css`
                           &.ui.message {
                               margin-bottom: 1rem;
                           }

                           &.blue.info.circle.icon {
                               margin-top: 1rem;
                               width: 16px;
                               height: 16px;
                               vertical-align: text-top;
                           }
                       `}>
              <FeatureInfo.Text><strong>Bienvenu.e sur votre nouveau tableau de bord ULTY</strong></FeatureInfo.Text>
              <FeatureInfo.Text>
                  Ce tableau de bord vous offre une vision de votre activité en temps réel.  Suivez vos indicateurs commerciaux et opérationnels, identifiez les points d’amélioration et prenez des décisions immédiates.
                  Vous pouvez aussi analyser la performance de votre catalogue, repérer vos produits les plus contributifs et ajuster vos mark-ups de prix pour optimiser votre rentabilité.
              </FeatureInfo.Text>
          </FeatureInfo>

          {isProviderAPos(user.provider) && <IntegrationSection />}

          <BusinessPerformanceSection />

          <OperationalPerformanceSection />

          {!user.isLoggedInOwnScope && <OfferPerformanceSection/>}
      </>
    )
}

export { Dashboard }
